import { render } from "./StepCard.vue?vue&type=template&id=52b2bd6a&scoped=true"
import script from "./StepCard.vue?vue&type=script&lang=js"
export * from "./StepCard.vue?vue&type=script&lang=js"

import "./StepCard.vue?vue&type=style&index=0&id=52b2bd6a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b2bd6a"]])

export default __exports__